import { render } from "./TranslationsToolbar.vue?vue&type=template&id=24342583&scoped=true"
import script from "./TranslationsToolbar.vue?vue&type=script&lang=js"
export * from "./TranslationsToolbar.vue?vue&type=script&lang=js"

import "./TranslationsToolbar.vue?vue&type=style&index=0&id=24342583&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\craft-cms-3-plugins\\craft3-translate\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24342583"]])

export default __exports__